import React, { useState } from 'react';

import Button from '@atlaskit/button';
import Popup from '@atlaskit/popup';

import {
  OverflowButtonStyled,
  ProjectListContainerStyled,
} from './MultiValueWithOverflow.styled';

type Props = {
  overflowValues: Array<JSX.Element>;
};

export default function MultiValuePopup({
  overflowValues,
}: Props): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popup
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      placement='bottom-end'
      content={() => (
        <ProjectListContainerStyled>
          {overflowValues}
        </ProjectListContainerStyled>
      )}
      trigger={(triggerProps) => (
        <OverflowButtonStyled>
          <Button
            spacing='compact'
            style={{
              fontSize: '12px',
              borderRadius: '2px',
            }}
            onClick={() => setIsOpen(true)}
            {...triggerProps}
          >
            +{overflowValues.length}
          </Button>
        </OverflowButtonStyled>
      )}
    />
  );
}
